customElements.get("product-form") || customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
        super(), this.form = this.querySelector("form"), this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), this.cartNotification = document.querySelector("cart-notification")
    }

    async getCartData() {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch cart data');
        return await response.json();
      } catch (error) {
        console.error('Error fetching cart data:', error);
        return null;
      }
    }

    async handleClevertapEvents(element, eventName) {
      if (!element) return;
      
      const productId = element.dataset?.productId;
      const productUrl = element.dataset?.productUrl;
      const productTitle = element.dataset?.productTitle;
      const productCategory = element.dataset?.productCategory;
      const productPrice = parseInt(element.dataset?.price);
      const productCompareAtPrice = parseInt(element.dataset?.retailPrice);
      const discountPrice = productCompareAtPrice - productPrice;
      let eventData = null;
      if(element === this.form.querySelector('[data-template="product"]')){
        const cartData = await this.getCartData();
        const cartTotalQuantity = cartData ? cartData.item_count : 0;
        const userLoggedIn = element.dataset?.userLoggedIn;
        eventData = {
          "Product url": productUrl,
          "product name": productTitle,
          "Category": productCategory,
          "Price": productPrice,
          "Discount price": discountPrice,
          "Cart total quantity": cartTotalQuantity,
          "user logged in": userLoggedIn
        };
      } else if(element === this.form.querySelector('[data-section-type="Product recommendations"]')){
        const pdpProductId = element?.dataset?.pdpProductId || 'N/A';
        const pdpProductUrl = element?.dataset?.pdpProductUrl || 'N/A';
        const pdpProductName = element?.dataset?.pdpProductName || 'N/A';
        const pdpProductCategory = element?.dataset?.pdpProductCategory || 'N/A';
        const ymalProductUrl = productUrl.split('?')[0];
        const userLoggedIn = element?.dataset?.userLoggedIn;
        eventData = {
          "Product id": pdpProductId,
          "Product URL": pdpProductUrl,
          "Product name": pdpProductName,
          "Product category": pdpProductCategory,
          "YMAL product id": productId,
          "YMAL product url": ymalProductUrl,
          "YMAL product name": productTitle,
          "YMAL product category": productCategory,
          "user logged in": userLoggedIn,
          "ATC done": "Yes"
        }
      } else {
        eventData = {
          "Product url": productUrl,
          "product name": productTitle,
          "Category": productCategory,
          "Price": productPrice,
          "Discount price": discountPrice
        };
      }
      clevertap.event.push(eventName, eventData);
    }
  
    handleAddToCartEvents() {
      const isProductPageATC = this.form.querySelector('[data-template="product"]');
      const isCartRewardATC = this.form.querySelector('.reward-product-form__submit');
      const isCartFbtATC = this.form.querySelector('[data-section="frequently-bought"]'); //Frequently bought together
      const isProductRecommendationsATC = this.form.querySelector('[data-section-type="Product recommendations"]');
      if(isProductPageATC){
        this.handleClevertapEvents(isProductPageATC, 'PDP_ATC_clicked');
      }
      if(isCartRewardATC){
        this.handleClevertapEvents(isCartRewardATC, 'Cart_Rewards_ATC');
      }
      if(isCartFbtATC){
        this.handleClevertapEvents(isCartFbtATC, 'Cart_FBT_ATC');
      }
      if(isProductRecommendationsATC){
        this.handleClevertapEvents(isProductRecommendationsATC, 'PDP_YMAL_ATC');
      }
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
     // Add to cart button is clicked the popup is display product added to cart in all pages except cart page
        if(this.cartNotification){
          this.cartNotification.setActiveElement(document.activeElement);
        const submitButton = this.querySelector('[type="submit"]');
        let collectionBundel = submitButton.dataset.collectionBundel
        let MaxQty = submitButton.dataset.maxQuantity
        let MaxCollectionQty = submitButton.dataset.collectionMaxQuantity
        let bundel = submitButton.dataset.bundel
        submitButton.setAttribute("disabled", !0), submitButton.classList.add("loading");
       let body = '';
        if(submitButton.closest('mm-bundle-check')){
          body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form)),
            properties:{
              isBundleProduct : bundel,
              isCollectionBUndel : collectionBundel,
              maxBundelQuantity : MaxQty,
              maxCollectionBundel : MaxCollectionQty
              
            },
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          });
        }else{
          body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form)),
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          });
        }
        fetch(`${routes.cart_add_url}`, {
            ...fetchConfig("javascript"),
            body: body
        }).then(response => response.json()).then(parsedState => {
            this.cartNotification.renderContents(parsedState)
            this.handleAddToCartEvents();
        }).then((function(cart) {
            mmajaxcart.AjaxcartRender();
        })).catch(e => {
            console.error(e)
        }).finally(async () => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
          if(submitButton.closest('mm-bundle-check')){
            submitButton.closest('mm-bundle-check').update()
          }
          if (typeof removeDiscount === 'function') {
            await removeDiscount();
         }
         let quantityHandler = submitButton.closest('product-form').querySelector('customaddtocart-quantity-handler');
         if(quantityHandler){
           submitButton.style.display = 'none';
           quantityHandler.style.display = 'flex';
           quantityHandler.querySelector('.product-quantity__text').setAttribute('data-cart-quantity', 1);
           quantityHandler.querySelector('.product-quantity__text').setAttribute('data-cart-variant', this.form.querySelector('[name="id"]').value);
           quantityHandler.querySelector('.product-quantity__text').textContent = 1;     
        }   
        })
      } else {
          // In cart page add to cart button is clicked the product added to cart and cart page is refresh
          const submitButton = this.querySelector('[type="submit"]');
          let MaxQty = submitButton.dataset.maxQuantity
          let MaxCollectionQty = submitButton.dataset.collectionMaxQuantity
          let collectionBundel = submitButton.dataset.collectionBundel
          let bundel = submitButton.dataset.bundel

        submitButton.setAttribute("disabled", !0), submitButton.classList.add("loading");
        let body = '';
        if(submitButton.closest('mm-bundle-check')){
          body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form)),
            properties:{
              isBundleProduct : bundel,
              isCollectionBUndel : collectionBundel,
              maxBundelQuantity : MaxQty,
              maxCollectionBundel : MaxCollectionQty
              
            },
            sections_url: window.location.pathname
          });
        }else{
          body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form)),
            sections_url: window.location.pathname
          });
        }
        fetch(`${routes.cart_add_url}`, {
            ...fetchConfig("javascript"),
            body: body
        }).then(response => response.json()).then(parsedState => {
            location.reload();
        }).then((function(cart) {
            mmajaxcart.AjaxcartRender()
            window.scrollTo({top:100});
        })).catch(e => {
            console.error(e)
        }).finally(() => {
           submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
            if(submitButton.closest('mm-bundle-check')){
              submitButton.closest('mm-bundle-check').update()
            }
            let quantityHandler = submitButton.closest('product-form').querySelector('customaddtocart-quantity-handler');
            if(quantityHandler){
              submitButton.style.display = 'none';
              quantityHandler.style.display = 'flex';
              quantityHandler.querySelector('.product-quantity__text').setAttribute('data-cart-quantity', 1);
              quantityHandler.querySelector('.product-quantity__text').setAttribute('data-cart-variant', this.form.querySelector('[name="id"]').value);
              quantityHandler.querySelector('.product-quantity__text').textContent = 1;     
            } 
        })
      }
    }
});